import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class HttpError extends EluveError {
  static override readonly errorName = 'HttpError';
  readonly logLevel: LogLevel = 'error';

  constructor(message = 'HTTP request failed', args?: EluveErrorArgs) {
    super(message, args);
  }
}
